module.exports = __webpack_public_path__ + "static/libation-logo-ad6c41353ebaa61561afd392a6f590f7.png";